<template>
  <v-system-bar :color="color" :dark="dark" dense>
    <span>{{title}}</span>
    <slot name="actionTemplate"></slot>

    <v-spacer></v-spacer>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
      <span>{{$t('Close')}}</span>
    </v-tooltip>
  </v-system-bar>
</template>
<script>
export default {
  name: "DocumentActionHeader",
  props: {
    title: {
      type: String
    },
    color: {
      type: String,
      default: "blue"
    },
    dark: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    close() {
      this.$emit("on-close-click");
    }
  }
};
</script>